import { z } from 'zod';

export const AccessCodeCustomInfoValidationSchema = z.object({
  /**
   * Always present in form state: the modal seeds it with the code's existing
   * custom infos, or an empty array when there are none.
   */
  accessCodeCustomInfos: z.array(
    z.object({
      fgCustomInformationId: z.string(),
      informationValue: z.string(),
      semanticName: z.string(),
    })
  ),
});

export type AccessCodeCustomInfoValidation = z.infer<
  typeof AccessCodeCustomInfoValidationSchema
>;
